export default __webpack_public_path__ + "static/media/logo.6f0d1aeb.png";